// extracted by mini-css-extract-plugin
export default {"deleteButton":"TimeOffTypeSwitcher_deleteButton__Jc1ge"};